import { API } from "src/domains/shared/utils/amplifyCompat";
import { DRONESQUARE_API_GATEWAY } from "src/domains/shared/constants/constants";

type Props = {
  projectId: number;
  timeSeriesId: number;
  imageId: number | undefined;
};

const getPointPositionFromgetImageKey = async ({
  projectId,
  timeSeriesId,
  imageId,
}: Props) => {
  if (!imageId) {
    return null;
  }
  try {
    const data = await API.get(
      DRONESQUARE_API_GATEWAY,
      `calculation/projects/${projectId}/time_projects/${timeSeriesId}/function/datapoint/image?image_id=${imageId}&response=[point_x,point_y,camera_x,camera_y,camera_z,camera_omega,camera_phi,camera_kappa,point_lng,point_lat]`,
      {}
    );
    return data;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

export default getPointPositionFromgetImageKey;
